import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { videoCategories } from "../../constants";
import Categories from "../Components/Categories";
import IndexHeader from "../../Shared/IndexHeader";
import MultiPublish from "./Components/MultiPublish";
import { usePrevious } from "../../Shared/CustomHooks";
import VideoIndexContainer from "./VideoIndexContainer";
import VideoPageHeader from "./Components/VideoPageHeader";
import TranscriptModel from "../../Shared/DownloadTranscriptModel";
import { getVideoUploadDetails } from "../../Pages/Home/home_actions";
import { updateTutorialState } from "../../Shared/Tutorials/TutorialActions";
import UploadVideoProcess from "../../Shared/VideosProcess/UploadVideoProcess";
import {
  updateVideoPageState,
  updateParams,
  downloadAllTranscript,
  fetchCampaignList,
  doResetFiltersVideos,
  updateCampaignState,
} from "./VideoActions";
import Cookies from "js-cookie";
import CampaignListPage from "./CampaignListPage";
import VideoHeaderNew from "../../Shared/VideoHeaderNew";

const CampaignDetailPage = () => {
  const [search, setSearch] = useState("");
  const [openTranscriptModel, setOpenTranscriptModel] = useState(false);
  const [uploadVideoModal, setUploadVideoModal] = useState(false);
  const [limitReachedModal, setLimitReachedModal] = useState(false);
  const [openMultiPublish, setOpenMultiPublish] = useState(false);
  const [uploadVideoDetails, setUploadVideoDetails] = useState({});

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const videos = useSelector((state) => state.videos);
  const videoParams = useSelector((state) => state.videoParams);
  const roles = useSelector((state) => state.navbarStatsReducer.roles);
  const count = useSelector((state) => state.videoData.count);

  const widgetVideoCount = useSelector(
    (state) => state.videoData.widgetVideoCount
  );
  const totalPages = useSelector((state) => state.videoData.totalPages);
  const loadingTranscriptPdf = useSelector(
    (state) => state.downloadTranscript.loadingTranscriptPdf
  );

  const currentBrand = useSelector((state) => state.selectedBrandReducer);
  const campaignName = useSelector(
    (state) => state.videoPageStates.campaignsState.campaignName
  );
  const campaignId = useSelector(
    (state) => state.videoPageStates.campaignsState.campaignId
  );
  const isCategoryPage = useSelector(
    (state) => state.videoPageStates.isCategoryPage
  );
  const isCampaignListPage = useSelector(
    (state) => state.videoPageStates.isCampaignListPage
  );
  const { brand_id } = currentBrand;
  const prevBrand = usePrevious(brand_id);

  useEffect(() => {
    if (!loadingTranscriptPdf) setOpenTranscriptModel(false);
  }, [loadingTranscriptPdf]);

  useEffect(() => {
    if (!campaignId) {
      navigate("/videos");
    }
  }, [!campaignId]);

  const truncateName = (name, wordLimit) => {
    const words = name.split(" ");
    if (words.length > wordLimit) {
      return words.slice(0, wordLimit).join(" ") + "...";
    }
    return name;
  };

  useEffect(() => {
    if (campaignId) {
      const truncatedName = truncateName(campaignName, 2);
      dispatch(
        updateParams({
          tab: "Campaigns",
          transcriptView: false,
          is_widget: false,
          search: "",
          page: 1,
          isTrashTab: false,
          isFlaggedTab: false,
          isFavoriteTab: false,
          isCampaignTab: true,
          campaignId: `${campaignId}`,
        })
      );
      dispatch(
        updateVideoPageState({
          isCampaignListPage: false,
          isCategoryPage: false,
        })
      );

      const campaignPageBreadcrumb = [
        {
          name: "Campaigns",
          tab: "Campaigns",
          type: "tab",
          link: "/videos/campaigns",
          page: "videos",
        },
        {
          name: `${truncatedName}`,
          isCampaign: true,
          // tab: "Campaigns",
          // type: "tab",
          link: "",
          // page: "videos",
        },
      ];
      dispatch(
        updateCampaignState({
          breadcrumbs: campaignPageBreadcrumb,
          showCampaignHeader: true,
        })
      );
      dispatch(
        updateParams({
          isCampaignTab: false,
          updateParamsOnly: true,
        })
      );
    }
  }, []);

  const fetchCampaignData = async () => {
    const manufacturerId = Cookies.get("bId") || brand_id;
    fetchCampaignList(manufacturerId)
      .then((response) => {
        dispatch(
          updateVideoPageState({
            campaigns: response?.campaign,
          })
        );
      })
      .catch(() => {
        console.log("error fetchCampaignList");
      });
  };

  const categoryHandler = (category) => {
    // console.log(category);
    fetchCampaignData();
    const activeTab =
      category.tab === "flagged" ||
      category.tab === "favorites" ||
      category.tab === "Campaigns" ||
      category.tab === "Trash"
        ? "My Videos"
        : category.tab;

    if (category.tab === "Campaigns") {
      dispatch(
        updateParams({
          tab: "Campaigns",
          transcriptView: false,
          is_widget: false,
          search: "",
          page: 1,
          isTrashTab: false,
          isFlaggedTab: false,
          isFavoriteTab: false,
          isCampaignTab: true,
          updateParamsOnly: true,
        })
      );
      dispatch(
        updateVideoPageState({
          isCategoryPage: false,
          isCampaignListPage: true,
        })
      );
      navigate("/videos/campaigns");
    } else {
      // if (category.tab) {
      // Cookies.set("activeTab", JSON.stringify(category));
      dispatch(
        updateCampaignState({ breadcrumbs: [], showCampaignHeader: false })
      );
      // dispatch(fetchNotes("video"));

      dispatch(
        updateParams({
          tab: activeTab,
          transcriptView: false,
          is_widget: false,
          search: "",
          page: 1,
          campaignId: "",
          isTrashTab: category.tab === "Trash",
          isFlaggedTab: category.tab === "flagged",
          isFavoriteTab: category.tab === "favorites",
          isCampaignTab: category.tab === "Campaigns",
        })
      );
      dispatch(updateVideoPageState({ isCategoryPage: false }));

      // @TODO:THIS SHOULD BE UPDATE AFTER SAVE VIDEO BACKEND AVAILABLE
      if (localStorage.getItem("toturialScreen") === "firstVideo") {
        dispatch(
          updateTutorialState({
            isTutorial: true,
            activeTutorial: "first-video",
            activeStep: 1,
            totalSteps: 2,
          })
        );
      }

      if (
        localStorage.getItem("firstVideoAnalysisId")?.split(",")[1] ==
        "completed"
      ) {
        dispatch(
          updateTutorialState({
            isTutorial: true,
            activeTutorial: "first-video-analyzed",
            activeStep: 2,
            totalSteps: 2,
          })
        );
      }
      // }
    }
  };

  const activeTab =
    Cookies.get("activeTab") && JSON.parse(Cookies.get("activeTab"));

  useEffect(() => {
    if (activeTab?.tab) {
      categoryHandler(activeTab);
    }
  }, []);

  const handleCloseTranscript = () => setOpenTranscriptModel(false);

  const verifiedCount = (
    fileType,
    downloadState = true,
    loadingTranscriptPdf = true
  ) => {
    dispatch(
      downloadAllTranscript({ downloadState, loadingTranscriptPdf, fileType })
    );
  };

  const downloadHandle = (fileType) => {
    if (count >= 50) {
      setOpenTranscriptModel(true);
      verifiedCount(fileType, false, false);
    } else {
      verifiedCount(fileType);
    }
  };

  const getBrandDetails = () => {
    getVideoUploadDetails({})
      .then((response) => {
        setUploadVideoDetails(response);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getBrandDetails();
  }, []);

  useEffect(() => {
    if (prevBrand && prevBrand !== brand_id) {
      getBrandDetails();
      setUploadVideoDetails({});
      fetchCampaignData();
    }
  }, [brand_id]);

  const handleCloseMultiPublish = () => setOpenMultiPublish(false);

  useEffect(() => {
    // This code will run when the component mounts
    return () => {
      // This code will run when the component unmounts
      dispatch(
        updateCampaignState({ breadcrumbs: [], showCampaignHeader: false })
      );
    };
  }, [dispatch]);

  // const headerElements = (
  //   <VideoPageHeader
  //     search={search}
  //     setSearch={setSearch}
  //     downloadHandle={downloadHandle}
  //     uploadVideoDetails={uploadVideoDetails}
  //     setLimitReachedModal={setLimitReachedModal}
  //     setUploadVideoModal={setUploadVideoModal}
  //     setOpenMultiPublish={setOpenMultiPublish}
  //     tabs={["My Videos", "Competition"]}
  //   />
  // );

  return (
    <>
      <IndexHeader
        // headerElements={headerElements}
        indexName="Videos"
        page="videos"
        tabs={["My Videos", "Competition"]}
        roles={roles}
        uploadVideoDetails={uploadVideoDetails}
        setUploadVideoModal={setUploadVideoModal}
      />
      {!isCampaignListPage && (
        <VideoPageHeader
          cardType="Video"
          search={search}
          setSearch={setSearch}
          downloadHandle={downloadHandle}
          uploadVideoDetails={uploadVideoDetails}
          setLimitReachedModal={setLimitReachedModal}
          setUploadVideoModal={setUploadVideoModal}
          setOpenMultiPublish={setOpenMultiPublish}
          tabs={["My Videos", "Competition"]}
        />
      )}
      <TranscriptModel
        open={openTranscriptModel}
        handleClose={handleCloseTranscript}
        handleDownloadReport={verifiedCount}
      />
      <UploadVideoProcess
        uploadVideoDetails={uploadVideoDetails}
        setUploadVideoModal={setUploadVideoModal}
        uploadVideoModal={uploadVideoModal}
        limitReachedModal={limitReachedModal}
        setLimitReachedModal={setLimitReachedModal}
        getBrandDetails={getBrandDetails}
      />
      <MultiPublish
        open={openMultiPublish}
        videos={videos}
        onClose={handleCloseMultiPublish}
        totalVideoCount={widgetVideoCount || 0}
        totalPages={totalPages}
        params={videoParams}
        pathname="videos"
      />
      <VideoIndexContainer />
    </>
  );
};

export default CampaignDetailPage;
